var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { class: _vm.getClass, attrs: { outlined: "" } },
    [_c("v-card-text", [_vm._v(" " + _vm._s(this.text) + " ")])],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }